import { React, useState } from "react";
import { createUser } from "../requests";
import { Redirect } from "react-router-dom";

export const CreateAccount = () => {
  const [error, setError] = useState(false);
  const [account, setAccount] = useState({
    email: "",
    password: "",
    cpassword: "",
    firstname: "",
  });

  const checkFieldNotEmpty = (input) => {
    if (
      input &&
      input.email !== "" &&
      input.password !== "" &&
      input.cpassword !== "" &&
      input.firstname !== ""
    ) {
      return true;
    } else {
      return false;
    }
  };

  const checkEmail = (input) => {
    var validRegex =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (input && input.email && validRegex.test(input.email)) {
      return true;
    } else {
      return false;
    }
  };

  const checkPass = (input) => {
    if (input && input.password === input.cpassword) {
      return true;
    } else {
      return false;
    }
  };

  const handleChange = (e) => {
    e.preventDefault();
    const stateAccount = { ...account, [e.target.name]: e.target.value };
    setAccount(stateAccount);
  };

  const fetchAccount = async () => {
    try {
      delete account.cpassword;
      const accountInput = await createUser(account);
      setAccount(accountInput);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    checkFieldNotEmpty(account) === true &&
    checkEmail(account) === true &&
    checkPass(account) === true
      ? setError(false)
      : setError(true);
    // temps de chargement !
    if (
      checkFieldNotEmpty(account) === true &&
      checkEmail(account) === true &&
      checkPass(account) === true
    ) {
      console.log("error", error);
      fetchAccount();
      alert("Merci pour la création de votre compte !");
      return Redirect("/login");
    }
  };

  const handleResetForm = () => {
    setAccount({
      email: "",
      password: "",
      cpassword: "",
      firstname: "",
    });
    setError(false);
  };

  return (
    <div className="container my-5">
      <div className="row">
        <h3>Créer son compte</h3>
      </div>
      <div className="row my-6">
        <form>
          <div className="field">
            <label className="label">Pseudo</label>
            <div className="control">
              <input
                className="input"
                type="text"
                name="firstname"
                value={account.firstname}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="field">
            <label className="label">Email</label>
            <div className="control">
              <input
                className="input"
                type="email"
                name="email"
                value={account.email}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="field">
            <label className="label">Mot de passe</label>
            <div className="control">
              <input
                className="input"
                type="password"
                name="password"
                value={account.password}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="field">
            <label className="label">Confirmer le mot de passe</label>
            <div className="control">
              <input
                className="input"
                type="password"
                name="cpassword"
                value={account.cpassword}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="field">
            <p className="help is-danger">
              {error &&
                "Erreur. Veuillez compléter ou modifier le formulaire en vérifiant vos informations"}
            </p>
          </div>
          <div className="row">
            <div className="col-md-5 mr-3 control">
              <button
                className="button bg-danger is-link"
                onClick={handleResetForm}
              >
                Effacer
              </button>
            </div>
            <div className="col-md-5 control">
              <button
                className="button bg-primary is-link"
                onClick={handleSubmit}
              >
                Enregistrer
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};
